import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';
import moment from 'moment';

Vue.use(Vuex);

const loading = {};
const store = new Vuex.Store({
  state: {
    companies: {},
    orders: {},
    users: {},
    menu: {},
    chefsChoice: {},
    substitutions: {},
    plans: {},
    streams: []
  },
  getters: {
    getCompanies: (state) => {
      return state.companies;
    },
    getOrders: (state) => {
      return state.orders;
    },
    getUsers: (state) => {
      return state.users;
    },
    getPlans: (state) => {
      return state.plans;
    },
    getStreams: (state) => {
      return state.streams;
    },
    getMenu: (state) => {
      return state.menu;
    },
    getChefsChoice: (state) => {
      return state.chefsChoice;
    },
    getSubstitutions: (state) => {
      return state.substitutions;
    }
  },
  mutations: {
    SET_COMPANIES(state, companies) {
      state.companies = companies;
    },
    SET_ORDERS(state, {orders, week}) {
      Vue.set(state.orders, week, orders);
    },
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_PLANS(state, plans) {
      state.plans = plans;
    },
    SET_STREAMS(state, streams) {
      state.streams = streams;
    },
    REFRESH_ORDERS(state) {
      state.orders = JSON.parse(JSON.stringify(state.orders));
    },
    SET_MENU(state, menu) {
      state.menu = menu;
    },
    SET_CHEFS_CHOICE(state, chefsChoice) {
      state.chefsChoice = chefsChoice;
    },
    SET_SUBSTITUTIONS(state, substitutions) {
      state.substitutions = substitutions;
    }
  },
  actions: {
    initCompanies({commit}) {
      let db = firebase.database();
      let companiesRef = db.ref("companies/");
      companiesRef.once("value", (snapshot) => {
        let companies = snapshot.val();
        commit('SET_COMPANIES', companies);
      });
    },
    initOrders({commit, state}, date) {
      date = moment(date).day(5);
      let week = date.format('gggg_w'); // date.year() + "_" + date.week();
      loading.orders = loading.orders || {};
      if (!loading.orders[week]) {
        let db = firebase.database();
        let ordersRef = db.ref(`orders/${week}/`);
        // console.log(`loading orders/${week}/`);
        loading.orders = loading.orders || {};
        loading.orders[week] = new Promise(((resolve, reject) => {
          ordersRef.on("value", snapshot => {
            // console.log(`loaded orders/${week}/`, snapshot.val());
            const orders = snapshot.val();
            commit('SET_ORDERS', {orders, week});
            resolve(orders);
          });
        }));
      }
      return loading.orders[week];
    },
    initUsers({commit}) {
      let db = firebase.database();
      let usersRef = db.ref("users/");
      usersRef.once("value", snapshot => {
        let users = snapshot.val();
        commit('SET_USERS', users);
      });
    },
    initPlans({commit}) {
      let db = firebase.database();
      let plansRef = db.ref("plans/");
      plansRef.once("value", snapshot => {
        let plans = snapshot.val();
        commit('SET_PLANS', plans);
      });
    },
    initStreams({commit}) {
      let db = firebase.database();
      let streamsRef = db.ref("streams/");
      streamsRef.once("value", snapshot => {
        let streams = snapshot.val();
        commit('SET_STREAMS', streams);
      });
    },
    initSubstitutions({commit}) {
      let db = firebase.database();
      let substitutionsRef = db.ref("meals/substitutions");
      substitutionsRef.once("value", snapshot => {
        let substitutions = snapshot.val();
        commit('SET_SUBSTITUTIONS', substitutions);
      });
    },
    initMenu({commit}) {
      let db = firebase.database();
      let menuRef = db.ref("menu/");
      menuRef.once("value", (snapshot) => {
        let menu = snapshot.val();
        commit('SET_MENU', menu);
      });
    },
    async setPackedOrder({commit}, {}) {
      let index = moment(this.date).day() - 1;
      let db = firebase.database();
      let update = {};
      update[index] = this.pack;
      await db.ref("fed_orders/" + item.key + "/packed").update(update);
      let i = this.items.findIndex(order => order.key === item.key);
      this.items[i].packed = this.items[i].packed || {};
      this.$set(this.items[i].packed, index, this.pack);
    },
    getMealById(_, id) {
      return new Promise((resolve, reject) => {
        let db = firebase.firestore();
        let mealRef = db.collection('meals');

        mealRef.where('id', '==', id).get()
          .then(snapshot => {
            let keysToget = ["id", "name", "tod", "prep1", "prep2", "prep3", "prep4", "assigned_date", "code"];
            snapshot.forEach(doc => {
              let meal = doc.data();
              let mealData = {};
              let ingredients = '';
              for (let key of keysToget) {
                mealData[key] = meal[key];
              }

              for (let ingredient of meal.ingredients) {
                if (ingredient.food_name) {
                  let indexOfComma = ingredient.food_name.indexOf(",");
                  if (indexOfComma > -1) {
                    ingredient.food_name = ingredient.food_name.substring(0, indexOfComma);
                  }
                  if (ingredients === '') {
                    ingredients = ingredient.food_name;
                  } else {
                    ingredients = ingredients + ', ' + ingredient.food_name;
                  }
                }
              }
              mealData.ingredients = ingredients;
              resolve(mealData);
            });
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    logout({commit}) {
      return firebase.auth().signOut();
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store.js